import IpubRadio from './src/main'

/* istanbul ignore next */
IpubRadio.install = function(Vue) {
  Vue.component(IpubRadio.name, IpubRadio)
}

export default IpubRadio
